export const PRICING_PLANS = [
  {
    id: "basic",
    name: "Basic",
    price: 40,
    period: "user per month",

    features: {
      calls: {
        recordings: true,
        listen: true,
        listenAndWhisper: true,
        callForwarding: true,
        blacklist: true,
      },

      devices: {
        softphone: true,
        phone: true,
        androidApp: true,
        iosApp: true,
      },

      clients: {
        clientCard: true,
        customFields: true,
        tasks: true,
        callStatuses: true,
        reports: true,
        statistics: true,
      },

      campaigns: {
        manage: false,
        scenario: false,
        customFields: false,
        reports: false,
      },

      features: {
        trueCaller: false,
        office365: false,
        whatsapp: false,
        billing: true,
        sms: false,
        fax: false,
        ai: false,
        api: false,
      },
    },
  },

  {
    id: "starter",
    name: "Starter",
    price: 60,
    period: "user per month",

    features: {
      calls: {
        recordings: true,
        listen: true,
        listenAndWhisper: true,
        callForwarding: true,
        blacklist: true,
      },

      devices: {
        softphone: true,
        phone: true,
        androidApp: true,
        iosApp: true,
      },

      clients: {
        clientCard: true,
        customFields: true,
        tasks: true,
        callStatuses: true,
        reports: true,
        statistics: true,
      },

      campaigns: {
        manage: true,
        scenario: true,
        customFields: true,
        reports: true,
      },

      features: {
        trueCaller: false,
        office365: false,
        whatsapp: false,
        billing: true,
        sms: true,
        fax: true,
        ai: true,
        api: true,
      },
    },
  },

  {
    id: "professional",
    name: "Professional",
    price: 80,
    period: "user per month",

    features: {
      calls: {
        recordings: true,
        listen: true,
        listenAndWhisper: true,
        callForwarding: true,
        blacklist: true,
      },

      devices: {
        softphone: true,
        phone: true,
        androidApp: true,
        iosApp: true,
      },

      clients: {
        clientCard: true,
        customFields: true,
        tasks: true,
        callStatuses: true,
        reports: true,
        statistics: true,
      },

      campaigns: {
        manage: true,
        scenario: true,
        customFields: true,
        reports: true,
      },

      features: {
        trueCaller: true,
        office365: true,
        whatsapp: true,
        billing: true,
        sms: true,
        fax: true,
        ai: true,
        api: true,
      },
    },
  },
];
